import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import Layout from './Layout';
import Login from './Login';
import Dashboard from './Dashboard';
import Objects from './Objects';
import Shifts from './Shifts';
import Users from './Users';
import Branches from './Branches';
import ProtectedRoute from './ProtectedRoute';
import Unauthorized from './Unauthorized';

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        
        <Route element={<Layout />}>
          <Route
            path="/"
            element={
              <ProtectedRoute roles={['admin', 'manager', 'operator', 'service']}>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/objects"
            element={
              <ProtectedRoute roles={['admin', 'manager', 'operator', 'service']}>
                <Objects />
              </ProtectedRoute>
            }
          />
          <Route
            path="/shifts"
            element={
              <ProtectedRoute roles={['admin', 'manager', 'operator', 'service']}>
                <Shifts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/branches"
            element={
              <ProtectedRoute roles={['admin']}>
                <Branches />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute roles={['admin']}>
                <Users />
              </ProtectedRoute>
            }
          />
        </Route>
        
        <Route path="*" element={<Login />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
